import { render, staticRenderFns } from "./Hjalpvivillhem.vue?vue&type=template&id=b36f5390"
import script from "./Hjalpvivillhem.vue?vue&type=script&lang=js"
export * from "./Hjalpvivillhem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports